module.exports = __webpack_public_path__ + "static/media/Biohazardous_Waste.85ca2863.svg";